// CryptoMart Comprehensive Mock API — Fully Fixed Version

const delay = (ms) => new Promise(r => setTimeout(r, ms));

const ls = {
  get: (k, d = null) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch { return d; } },
  set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
};

// ── Address generators ────────────────────────────────────────────────────
const genEVM = () => '0x' + Array.from({length:40}, () => '0123456789abcdef'[Math.floor(Math.random()*16)]).join('');
const genSol = () => Array.from({length:44}, () => '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'[Math.floor(Math.random()*58)]).join('');
const genBtc = () => 'tb1q' + Array.from({length:38}, () => '0123456789abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random()*36)]).join('');
const genXrp = () => 'r' + Array.from({length:33}, () => '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'[Math.floor(Math.random()*58)]).join('');
const genSui = () => '0x' + Array.from({length:64}, () => '0123456789abcdef'[Math.floor(Math.random()*16)]).join('');
const genWallet = () => { const e = genEVM(); return { EVM:e, BSC:e, ETH:e, MATIC:e, HYPE:e, ASTER:e, SOL:genSol(), BTC:genBtc(), XRP:genXrp(), SUI:genSui() }; };
const generateMnemonic = () => {
  const words = ['abandon','ability','able','about','above','absent','absorb','abstract','absurd','abuse','access','accident','account','accuse','achieve','acid','acoustic','acquire','across','act','action','actor','actress','actual','adapt','add','addict','address','adjust','admit','adult','advance','advice','aerobic','afford','afraid','again','age','agent','agree','ahead','aim','air','airport','aisle','alarm','album'];
  return Array.from({length:12}, () => words[Math.floor(Math.random()*words.length)]).join(' ');
};

// ── Fiat rates & crypto prices ────────────────────────────────────────────
const CRYPTO_PRICES = { BTC:83500, ETH:3200, BNB:580, SOL:145, USDT:1, SUI:1.85, ASTER:0.95, HYPE:18.5, XRP:0.62, MATIC:0.55 };

const FIAT_DATA = {
  NGN:{ name:'Nigerian Naira',       symbol:'₦',   region:'Africa',      rate:1580   },
  GHS:{ name:'Ghanaian Cedi',        symbol:'₵',   region:'Africa',      rate:15.2   },
  KES:{ name:'Kenyan Shilling',      symbol:'KSh', region:'Africa',      rate:129    },
  ZAR:{ name:'South African Rand',   symbol:'R',   region:'Africa',      rate:18.6   },
  UGX:{ name:'Ugandan Shilling',     symbol:'USh', region:'Africa',      rate:3720   },
  TZS:{ name:'Tanzanian Shilling',   symbol:'TSh', region:'Africa',      rate:2600   },
  ETB:{ name:'Ethiopian Birr',       symbol:'Br',  region:'Africa',      rate:127    },
  EGP:{ name:'Egyptian Pound',       symbol:'E£',  region:'Africa',      rate:49     },
  MAD:{ name:'Moroccan Dirham',      symbol:'MAD', region:'Africa',      rate:9.9    },
  XOF:{ name:'West African CFA',     symbol:'CFA', region:'Africa',      rate:615    },
  RWF:{ name:'Rwandan Franc',        symbol:'FRw', region:'Africa',      rate:1380   },
  ZMW:{ name:'Zambian Kwacha',       symbol:'ZK',  region:'Africa',      rate:27     },
  EUR:{ name:'Euro',                 symbol:'€',   region:'Europe',      rate:0.92   },
  GBP:{ name:'British Pound',        symbol:'£',   region:'Europe',      rate:0.79   },
  CHF:{ name:'Swiss Franc',          symbol:'Fr',  region:'Europe',      rate:0.9    },
  SEK:{ name:'Swedish Krona',        symbol:'kr',  region:'Europe',      rate:10.3   },
  NOK:{ name:'Norwegian Krone',      symbol:'kr',  region:'Europe',      rate:10.6   },
  PLN:{ name:'Polish Zloty',         symbol:'zł',  region:'Europe',      rate:3.95   },
  USD:{ name:'US Dollar',            symbol:'$',   region:'Americas',    rate:1      },
  CAD:{ name:'Canadian Dollar',      symbol:'CA$', region:'Americas',    rate:1.36   },
  BRL:{ name:'Brazilian Real',       symbol:'R$',  region:'Americas',    rate:5.1    },
  MXN:{ name:'Mexican Peso',         symbol:'MX$', region:'Americas',    rate:17.1   },
  ARS:{ name:'Argentine Peso',       symbol:'$',   region:'Americas',    rate:1020   },
  COP:{ name:'Colombian Peso',       symbol:'$',   region:'Americas',    rate:4150   },
  JPY:{ name:'Japanese Yen',         symbol:'¥',   region:'Asia',        rate:149    },
  CNY:{ name:'Chinese Yuan',         symbol:'¥',   region:'Asia',        rate:7.24   },
  INR:{ name:'Indian Rupee',         symbol:'₹',   region:'Asia',        rate:83     },
  KRW:{ name:'South Korean Won',     symbol:'₩',   region:'Asia',        rate:1330   },
  IDR:{ name:'Indonesian Rupiah',    symbol:'Rp',  region:'Asia',        rate:15700  },
  PHP:{ name:'Philippine Peso',      symbol:'₱',   region:'Asia',        rate:57     },
  THB:{ name:'Thai Baht',            symbol:'฿',   region:'Asia',        rate:35     },
  SGD:{ name:'Singapore Dollar',     symbol:'S$',  region:'Asia',        rate:1.34   },
  MYR:{ name:'Malaysian Ringgit',    symbol:'RM',  region:'Asia',        rate:4.65   },
  PKR:{ name:'Pakistani Rupee',      symbol:'₨',   region:'Asia',        rate:278    },
  AED:{ name:'UAE Dirham',           symbol:'د.إ', region:'Middle East', rate:3.67   },
  SAR:{ name:'Saudi Riyal',          symbol:'﷼',   region:'Middle East', rate:3.75   },
  KWD:{ name:'Kuwaiti Dinar',        symbol:'KD',  region:'Middle East', rate:0.307  },
  TRY:{ name:'Turkish Lira',         symbol:'₺',   region:'Middle East', rate:32     },
  AUD:{ name:'Australian Dollar',    symbol:'A$',  region:'Oceania',     rate:1.53   },
  NZD:{ name:'New Zealand Dollar',   symbol:'NZ$', region:'Oceania',     rate:1.63   },
};

// ── Seed admin ────────────────────────────────────────────────────────────
const ADMIN = {
  _id:'admin_shopcryptomart', email:'admin@shopcryptomart.com', password:'2004claude',
  username:'cryptomart_admin', role:'admin', country:'Nigeria', businessName:'CryptoMart HQ',
  createdAt:'2025-01-01T00:00:00.000Z', kybVerified:true, kybStatus:'approved', loyaltyPoints:9999,
  walletAddresses:{ EVM:'0x742d35Cc6634C0532925a3b8D9C4562ba98F4af2', BSC:'0x742d35Cc6634C0532925a3b8D9C4562ba98F4af2', SOL:'CmTstNET1111111111111111111111111111111111', BTC:'tb1qcm_admin_testnet_wallet', XRP:'rCryptoMartAdminHQTestnet' }
};
(() => {
  const users = ls.get('cm_mock_users') || [];
  if (!users.find(u => u.email === ADMIN.email)) { users.unshift(ADMIN); ls.set('cm_mock_users', users); }
  const wallets = ls.get('cm_mock_wallets') || {};
  if (!wallets[ADMIN._id]) {
    wallets[ADMIN._id] = {
      addresses: ADMIN.walletAddresses,
      balances: { USDT:5000, BNB:25, ETH:3.5, SOL:120, BTC:0.15, SUI:500, HYPE:80, ASTER:2000, XRP:3000, MATIC:0 },
      transactions: [
        {_id:'atx1', type:'deposit', currency:'BNB', amount:5, status:'confirmed', date:new Date(Date.now()-86400000).toISOString(), note:'BNB faucet'},
        {_id:'atx2', type:'deposit', currency:'USDT', amount:5000, status:'confirmed', date:new Date(Date.now()-172800000).toISOString(), note:'USDT airdrop'},
      ]
    };
    ls.set('cm_mock_wallets', wallets);
  }
})();

// ── Default products ──────────────────────────────────────────────────────
const DEFAULT_PRODUCTS = [
  { _id:'prod_1', title:'iPhone 15 Pro Max 256GB', description:'Brand new sealed Apple iPhone 15 Pro Max.', priceUSD:1200, displayCurrency:'ETH', displayPrice:0.375, displayPriceWithFee:0.3806, category:'Electronics & Accessories', images:[{url:'https://images.unsplash.com/photo-1696446701796-da61225697cc?w=500'}], seller:{_id:'seller_1', username:'techstore_ng', store:{name:'TechStore NG', rating:4.8}}, shipsFrom:{country:'Nigeria', city:'Lagos'}, stock:5, rating:4.8, reviewCount:12, sellerPlan:'pro' },
  { _id:'prod_2', title:'MacBook Pro 16" M3 Max', description:'Apple MacBook Pro with M3 Max chip, 32GB RAM, 1TB SSD.', priceUSD:3200, displayCurrency:'BTC', displayPrice:0.0383, displayPriceWithFee:0.0389, category:'Consumer Electronics', images:[{url:'https://images.unsplash.com/photo-1517336714731-489689fd1ca4?w=500'}], seller:{_id:'seller_1', username:'techstore_ng', store:{name:'TechStore NG', rating:4.8}}, shipsFrom:{country:'Nigeria', city:'Lagos'}, stock:3, rating:4.9, reviewCount:8, sellerPlan:'pro' },
  { _id:'prod_3', title:'PlayStation 5 Console Bundle', description:'Sony PS5 with DualSense controller and 2 games.', priceUSD:650, displayCurrency:'BNB', displayPrice:1.12, displayPriceWithFee:1.137, category:'Consumer Electronics', images:[{url:'https://images.unsplash.com/photo-1606813907291-d86efa9b94db?w=500'}], seller:{_id:'seller_2', username:'gamehub_africa', store:{name:'GameHub Africa', rating:4.7}}, shipsFrom:{country:'Ghana', city:'Accra'}, stock:10, rating:4.7, reviewCount:24, sellerPlan:'standard' },
  { _id:'prod_4', title:'Nike Air Jordan 1 Retro High', description:'Authentic Nike Air Jordan 1 Retro High OG.', priceUSD:450, displayCurrency:'SOL', displayPrice:3.103, displayPriceWithFee:3.15, category:'Fashion & Apparel', images:[{url:'https://images.unsplash.com/photo-1552346154-21d32810aba3?w=500'}], seller:{_id:'seller_3', username:'sneakerhead_ke', store:{name:'SneakerHead KE', rating:4.5}}, shipsFrom:{country:'Kenya', city:'Nairobi'}, stock:2, rating:4.5, reviewCount:6, sellerPlan:'basic' },
  { _id:'prod_5', title:'Samsung Galaxy S24 Ultra 512GB', description:'Samsung flagship with 200MP camera.', priceUSD:1100, displayCurrency:'USDT', displayPrice:1116.5, displayPriceWithFee:1116.5, category:'Electronics & Accessories', images:[{url:'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=500'}], seller:{_id:'seller_2', username:'gamehub_africa', store:{name:'GameHub Africa', rating:4.7}}, shipsFrom:{country:'Ghana', city:'Accra'}, stock:8, rating:4.6, reviewCount:15, sellerPlan:'standard' },
  { _id:'prod_6', title:'Louis Vuitton Neverfull MM', description:'Authentic LV Neverfull MM Monogram.', priceUSD:1800, displayCurrency:'ETH', displayPrice:0.5625, displayPriceWithFee:0.5709, category:'Fashion & Apparel', images:[{url:'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=500'}], seller:{_id:'seller_4', username:'luxurycollection', store:{name:'Luxury Collection', rating:5.0}}, shipsFrom:{country:'South Africa', city:'Johannesburg'}, stock:1, rating:5.0, reviewCount:3, sellerPlan:'pro' },
  { _id:'prod_7', title:'DJI Mini 4 Pro Drone', description:'DJI Mini 4 Pro with 4K HDR video.', priceUSD:760, displayCurrency:'BNB', displayPrice:1.31, displayPriceWithFee:1.33, category:'Electronics & Accessories', images:[{url:'https://images.unsplash.com/photo-1579829366248-204fe8413f31?w=500'}], seller:{_id:'seller_1', username:'techstore_ng', store:{name:'TechStore NG', rating:4.8}}, shipsFrom:{country:'Nigeria', city:'Lagos'}, stock:4, rating:4.8, reviewCount:9, sellerPlan:'pro' },
  { _id:'prod_8', title:'Rolex Submariner Date', description:'Genuine Rolex Submariner 41mm.', priceUSD:12000, displayCurrency:'BTC', displayPrice:0.1437, displayPriceWithFee:0.1459, category:'Jewelry & Watches', images:[{url:'https://images.unsplash.com/photo-1523170335258-f5ed11844a49?w=500'}], seller:{_id:'seller_4', username:'luxurycollection', store:{name:'Luxury Collection', rating:5.0}}, shipsFrom:{country:'South Africa', city:'Cape Town'}, stock:1, rating:5.0, reviewCount:2, sellerPlan:'pro' },
  { _id:'prod_9', title:'Tefal Air Fryer 4.2L', description:'Tefal Easy Fry with Rapid Air Technology.', priceUSD:120, displayCurrency:'USDT', displayPrice:121.8, displayPriceWithFee:121.8, category:'Home & Kitchen', images:[{url:'https://images.unsplash.com/photo-1648479248299-9e4b57ec4e35?w=500'}], seller:{_id:'seller_3', username:'sneakerhead_ke', store:{name:'SneakerHead KE', rating:4.5}}, shipsFrom:{country:'Kenya', city:'Mombasa'}, stock:15, rating:4.3, reviewCount:31, sellerPlan:'basic' },
  { _id:'prod_10', title:'Sony WH-1000XM5 Headphones', description:'Sony noise-cancelling wireless headphones.', priceUSD:350, displayCurrency:'SOL', displayPrice:2.414, displayPriceWithFee:2.45, category:'Electronics & Accessories', images:[{url:'https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=500'}], seller:{_id:'seller_2', username:'gamehub_africa', store:{name:'GameHub Africa', rating:4.7}}, shipsFrom:{country:'Ghana', city:'Accra'}, stock:6, rating:4.7, reviewCount:19, sellerPlan:'standard' },
  { _id:'prod_11', title:'Gucci GG Canvas Tote Bag', description:'Authentic Gucci GG Supreme Canvas tote.', priceUSD:980, displayCurrency:'ETH', displayPrice:0.306, displayPriceWithFee:0.311, category:'Fashion & Apparel', images:[{url:'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=500'}], seller:{_id:'seller_4', username:'luxurycollection', store:{name:'Luxury Collection', rating:5.0}}, shipsFrom:{country:'South Africa', city:'Johannesburg'}, stock:2, rating:4.9, reviewCount:5, sellerPlan:'pro' },
  { _id:'prod_12', title:'Adidas Ultraboost 22 Running', description:'Adidas Ultraboost 22 with BOOST midsole.', priceUSD:180, displayCurrency:'BNB', displayPrice:0.31, displayPriceWithFee:0.315, category:'Sports & Outdoors', images:[{url:'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500'}], seller:{_id:'seller_3', username:'sneakerhead_ke', store:{name:'SneakerHead KE', rating:4.5}}, shipsFrom:{country:'Kenya', city:'Nairobi'}, stock:7, rating:4.4, reviewCount:22, sellerPlan:'basic' },
];

const COMMISSION_RATES = [
  {_id:'cat1', category:'Electronics & Accessories', minRate:6, maxRate:8, defaultRate:7, shippingCut:3, description:'Smartphones, tablets, laptops and accessories'},
  {_id:'cat2', category:'Consumer Electronics', minRate:7, maxRate:9, defaultRate:8, shippingCut:3, description:'TVs, cameras, audio equipment'},
  {_id:'cat3', category:'Fashion & Apparel', minRate:10, maxRate:14, defaultRate:12, shippingCut:4, description:'Clothing, shoes, and fashion accessories'},
  {_id:'cat4', category:'Beauty & Personal Care', minRate:8, maxRate:12, defaultRate:10, shippingCut:3, description:'Skincare, makeup, and grooming'},
  {_id:'cat5', category:'Home & Kitchen', minRate:8, maxRate:12, defaultRate:10, shippingCut:4, description:'Appliances, cookware, furniture'},
  {_id:'cat6', category:'Jewelry & Watches', minRate:10, maxRate:15, defaultRate:12, shippingCut:2, description:'Fine jewelry, watches, accessories'},
  {_id:'cat7', category:'Sports & Outdoors', minRate:8, maxRate:12, defaultRate:10, shippingCut:5, description:'Fitness, outdoor gear, sports equipment'},
  {_id:'cat8', category:'General / Other', minRate:8, maxRate:12, defaultRate:10, shippingCut:4, description:'All other product categories'},
];

const PREMIUM_PLANS = {
  basic:   { name:'Basic',    monthlyUSD:9,  description:'For new sellers getting started', benefits:{featuredSpots:1, reducedCommission:1, prioritySupport:false, analyticsAccess:false, customStoreBanner:false} },
  standard:{ name:'Standard', monthlyUSD:29, description:'For growing sellers',            benefits:{featuredSpots:3, reducedCommission:2.5, prioritySupport:true, analyticsAccess:true, customStoreBanner:false} },
  pro:     { name:'Pro',      monthlyUSD:79, description:'For power sellers',              benefits:{featuredSpots:6, reducedCommission:5, prioritySupport:true, analyticsAccess:true, customStoreBanner:true} },
};

// ── Helpers ───────────────────────────────────────────────────────────────
const getProducts = () => { const p = ls.get('cm_mock_products'); if (!p || !p.length) { ls.set('cm_mock_products', DEFAULT_PRODUCTS); return DEFAULT_PRODUCTS; } return p; };
const getCurrentUser = () => { if (!localStorage.getItem('cm_mock_token')) return null; try { return JSON.parse(localStorage.getItem('cm_mock_current_user')); } catch { return null; } };
const getWallet = (uid) => { const w = ls.get('cm_mock_wallets') || {}; if (!w[uid]) { w[uid] = { addresses: genWallet(), balances:{USDT:0,BNB:0,ETH:0,SOL:0,BTC:0,SUI:0,HYPE:0,ASTER:0,XRP:0,MATIC:0}, transactions:[] }; ls.set('cm_mock_wallets', w); } return w[uid]; };
const saveWallet = (uid, data) => { const w = ls.get('cm_mock_wallets') || {}; w[uid] = data; ls.set('cm_mock_wallets', w); };
const getOrders = (uid) => { const all = ls.get('cm_mock_orders') || {}; if (!all[uid]) { all[uid] = []; ls.set('cm_mock_orders', all); } return all[uid]; };

// Deduplicate orders by _id (each order stored under buyer + seller key)
const getAllUniqueOrders = (filter = () => true) => {
  const all = ls.get('cm_mock_orders') || {};
  const seen = new Set();
  return Object.values(all).flat().filter(o => {
    if (o.viewAs === 'sale') return false; // skip seller copies
    if (seen.has(o._id)) return false;
    seen.add(o._id);
    return filter(o);
  });
};

// Enrich order with buyer/seller objects (admin UI reads .username)
const enrichOrder = (o) => {
  const users = ls.get('cm_mock_users') || [];
  const buyerUser  = users.find(u => u._id === (o.buyerId || o.buyer));
  const sellerUser = users.find(u => u._id === (o.sellerId || o.seller));
  return {
    ...o,
    buyer:  { _id: o.buyerId  || o.buyer,  username: buyerUser?.username  || o.buyerUsername  || o.buyer  },
    seller: { _id: o.sellerId || o.seller, username: sellerUser?.username || o.sellerUsername || o.seller },
  };
};

// Extract FormData field (handles both FormData and plain objects)
const getField = (data, key) => {
  if (!data) return undefined;
  if (typeof data.get === 'function') return data.get(key) || undefined;
  return data[key];
};

// ── MOCK API ──────────────────────────────────────────────────────────────
const mockApi = {

  // ── POST ────────────────────────────────────────────────────────────────
  post: async (endpoint, data = {}) => {
    await delay(400);
    const u = getCurrentUser();

    // Auth — login
    if (endpoint === '/auth/login') {
      const users = ls.get('cm_mock_users') || [];
      const found = users.find(x => x.email === data.email);
      if (!found || found.password !== data.password)
        throw { response:{ data:{ message:'Invalid email or password' } } };
      localStorage.setItem('cm_mock_token', 'mock_' + Date.now());
      localStorage.setItem('cm_mock_current_user', JSON.stringify(found));
      return { data: { token:'mock_' + Date.now(), user: found } };
    }

    // Auth — register
    if (endpoint === '/auth/register') {
      const users = ls.get('cm_mock_users') || [];
      if (users.find(x => x.email === data.email))     throw { response:{ data:{ message:'Email already registered' } } };
      if (users.find(x => x.username === data.username)) throw { response:{ data:{ message:'Username already taken' } } };
      const newUser = {
        _id: 'user_' + Date.now(), email: data.email, username: data.username,
        country: data.country, role: data.role || 'buyer', password: data.password,
        createdAt: new Date().toISOString(), kybVerified: false, kybStatus: 'not_submitted',
        loyaltyPoints: 0, walletAddresses: genWallet(),
      };
      users.push(newUser);
      ls.set('cm_mock_users', users);
      const wallets = ls.get('cm_mock_wallets') || {};
      wallets[newUser._id] = { addresses: newUser.walletAddresses, balances:{USDT:0,BNB:0,ETH:0,SOL:0,BTC:0,SUI:0,HYPE:0,ASTER:0,XRP:0,MATIC:0}, transactions:[] };
      ls.set('cm_mock_wallets', wallets);
      localStorage.setItem('cm_mock_token', 'mock_' + Date.now());
      localStorage.setItem('cm_mock_current_user', JSON.stringify(newUser));
      return { data: { token:'mock_' + Date.now(), user: newUser, walletMnemonic: generateMnemonic() } };
    }

    // Wallet — verify deposit / faucet
    if (endpoint === '/wallet/verify-deposit') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const w   = getWallet(u._id);
      const amt = parseFloat(data.amount) || 0;
      w.balances[data.currency] = (w.balances[data.currency] || 0) + amt;
      w.transactions.unshift({ _id:'tx_'+Date.now(), type:'deposit', currency:data.currency, amount:amt, status:'confirmed', date:new Date().toISOString(), txHash:data.txHash || ('0xFAUCET_'+Date.now()) });
      saveWallet(u._id, w);
      return { data: { message:`${amt} ${data.currency} credited to your wallet!` } };
    }

    // Wallet — withdraw
    if (endpoint === '/wallet/withdraw') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const w   = getWallet(u._id);
      const amt = parseFloat(data.amount) || 0;
      const cur = data.currency || 'USDT';
      if ((w.balances[cur] || 0) < amt) throw { response:{ data:{ message:'Insufficient balance' } } };
      w.balances[cur] -= amt;
      w.transactions.unshift({ _id:'tx_'+Date.now(), type:'withdrawal', currency:cur, amount:amt, status:'confirmed', date:new Date().toISOString(), note:`To: ${data.toAddress?.slice(0,14)}...` });
      saveWallet(u._id, w);
      return { data: { message:`${amt} ${cur} withdrawal initiated!` } };
    }

    // Orders — checkout
    if (endpoint === '/orders/checkout') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const allOrders = ls.get('cm_mock_orders') || {};
      if (!allOrders[u._id]) allOrders[u._id] = [];
      const autoReleaseAt = new Date(Date.now() + 7 * 86400000).toISOString();

      const newOrders = (data.items || []).map(item => {
        const cryptoAmt  = item.displayPriceWithFee
          ? parseFloat((item.displayPriceWithFee * (item.quantity || 1)).toFixed(8))
          : parseFloat(((item.priceUSD * 1.015 * (item.quantity || 1)) / (CRYPTO_PRICES[item.selectedCurrency] || 1)).toFixed(8));
        const totalUSD = parseFloat((item.priceUSD * 1.015 * (item.quantity || 1)).toFixed(2));
        return {
          _id:            'order_' + Date.now() + Math.random().toString(36).slice(2),
          orderNumber:    'CM' + Date.now().toString().slice(-6),
          // Store buyer + seller as OBJECTS — admin UI reads .username
          buyer:          { _id: u._id,           username: u.username            },
          seller:         { _id: item.sellerId,   username: item.sellerUsername   },
          // Also keep raw IDs for filtering
          buyerId:        u._id,
          sellerId:       item.sellerId,
          buyerUsername:  u.username,
          sellerUsername: item.sellerUsername,
          product:        { _id: item.productId, title: item.title, image: item.image },
          quantity:       item.quantity || 1,
          priceUSD:       item.priceUSD,
          totalUSD,
          currency:       item.selectedCurrency,
          paymentCurrency:item.selectedCurrency,
          cryptoAmount:   cryptoAmt,
          status:         'pending',
          escrowStatus:   'locked',
          autoReleaseAt,
          sellerIsTrusted:  false,
          deliveryEstimate: { type:'standard_shipping', minDays:5, maxDays:14 },
          shippingAddress:  data.shippingAddress,
          shipsFrom:        item.shipsFrom,
          createdAt:        new Date().toISOString(),
        };
      });

      allOrders[u._id].unshift(...newOrders);
      // Seller copies — flagged with viewAs:'sale' so admin doesn't double-count
      newOrders.forEach(o => {
        const sid = o.sellerId;
        if (sid) { if (!allOrders[sid]) allOrders[sid] = []; allOrders[sid].unshift({...o, viewAs:'sale'}); }
      });
      ls.set('cm_mock_orders', allOrders);

      // Deduct wallet
      const w = getWallet(u._id);
      newOrders.forEach(o => {
        w.balances[o.currency] = Math.max(0, (w.balances[o.currency]||0) - o.cryptoAmount);
        w.transactions.unshift({ _id:'tx_'+Date.now(), type:'payment', currency:o.currency, amount:o.cryptoAmount, status:'confirmed', date:new Date().toISOString(), note:`Order: ${o.product.title?.slice(0,20)}` });
      });
      saveWallet(u._id, w);
      return { data: { message:'Order placed!', orders: newOrders } };
    }

    // Orders — confirm delivery
    if (endpoint.match(/\/orders\/.+\/confirm-delivery/)) {
      const orderId = endpoint.split('/')[2];
      const all = ls.get('cm_mock_orders') || {};
      Object.keys(all).forEach(uid => { all[uid] = all[uid].map(o => o._id === orderId ? {...o, status:'completed', escrowStatus:'released'} : o); });
      ls.set('cm_mock_orders', all);
      return { data: { message:'Delivery confirmed! Funds released to seller.' } };
    }

    // Orders — dispute
    if (endpoint.match(/\/orders\/.+\/dispute/)) {
      const orderId = endpoint.split('/')[2];
      const all = ls.get('cm_mock_orders') || {};
      Object.keys(all).forEach(uid => { all[uid] = all[uid].map(o => o._id === orderId ? {...o, status:'disputed', dispute:{ reason:data.reason, raisedAt:new Date().toISOString() }} : o); });
      ls.set('cm_mock_orders', all);
      return { data: { message:'Dispute raised. Admin will review within 24 hours.' } };
    }

    // KYB — submit (SellerKYB sends FormData, not JSON)
    if (endpoint === '/kyb/submit') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const users = ls.get('cm_mock_users') || [];
      const idx   = users.findIndex(x => x._id === u._id);
      if (idx > -1) {
        // Extract fields whether data is FormData or plain object
        const kybFields = {
          businessName:    getField(data, 'businessName')    || '',
          businessType:    getField(data, 'businessType')    || '',
          businessCountry: getField(data, 'businessCountry') || '',
          submittedAt:     new Date().toISOString(),
          // Testnet: generate placeholder URLs for uploaded files
          faceVideoUrl:    getField(data, 'faceVideo')    ? `testnet://face-video-${u._id}.mp4`    : null,
          productVideoUrl: getField(data, 'productVideo') ? `testnet://product-video-${u._id}.mp4` : null,
          businessDocUrl:  getField(data, 'businessDoc')  ? `testnet://business-doc-${u._id}.pdf`  : null,
        };
        users[idx].kybStatus = 'pending';
        users[idx].kybData   = kybFields;
        users[idx].kyb       = kybFields;   // admin reads seller.kyb.businessName etc.
        ls.set('cm_mock_users', users);
        localStorage.setItem('cm_mock_current_user', JSON.stringify(users[idx]));
      }
      return { data: { message:'KYB submitted for review.' } };
    }

    // Products — create or update
    if (endpoint === '/products' || endpoint.startsWith('/products/')) {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const products  = getProducts();
      const isUpdate  = endpoint.length > 9;
      const productId = isUpdate ? endpoint.split('/').pop() : null;
      if (isUpdate) {
        const updated = products.map(p => p._id === productId ? {...p, ...data, _id:productId} : p);
        ls.set('cm_mock_products', updated);
        return { data: { product: updated.find(p => p._id === productId) } };
      } else {
        const newProd = { _id:'prod_'+Date.now(), ...data, seller:{_id:u._id, username:u.username, store:{name:u.businessName||u.username, rating:4.5}}, rating:0, reviewCount:0, createdAt:new Date().toISOString() };
        products.push(newProd);
        ls.set('cm_mock_products', products);
        return { data: { product: newProd } };
      }
    }

    // Support — create ticket
    if (endpoint === '/support/tickets') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const tickets = ls.get('cm_mock_tickets') || [];
      const t = { _id:'tkt_'+Date.now(), userId:u._id, username:u.username, subject:data.subject, message:data.message, status:'open', priority:'normal', createdAt:new Date().toISOString(), replies:[] };
      tickets.unshift(t);
      ls.set('cm_mock_tickets', tickets);
      return { data: { ticket: t } };
    }

    if (endpoint.match(/\/support\/tickets\/.+\/reply/)) {
      const tid = endpoint.split('/')[3];
      const tickets = ls.get('cm_mock_tickets') || [];
      const t = tickets.find(x => x._id === tid);
      if (t) { t.replies = t.replies||[]; t.replies.push({ from: ['admin','cs_staff'].includes(u?.role)?'support':'user', message:data.message, date:new Date().toISOString() }); ls.set('cm_mock_tickets', tickets); }
      return { data: { message:'Reply sent.' } };
    }

    if (endpoint.match(/\/support\/tickets\/.+\/rate/)) { return { data: { message:'Thank you!' } }; }

    // Seller — withdraw to bank
    if (endpoint === '/seller/wallet/withdraw-to-bank') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const w   = getWallet(u._id);
      const amt = parseFloat(data.amount) || 0;
      if ((w.balances['USDT']||0) < amt) throw { response:{ data:{ message:'Insufficient USDT balance' } } };
      w.balances['USDT'] -= amt;
      w.transactions.unshift({ _id:'tx_'+Date.now(), type:'withdrawal', currency:'USDT', amount:amt, status:'pending', date:new Date().toISOString(), note:`Bank: ${data.accountNumber||'—'}` });
      saveWallet(u._id, w);
      const wd = ls.get('cm_mock_withdrawals') || [];
      wd.unshift({ _id:'wd_'+Date.now(), userId:u._id, amount:amt, currency:'USDT', bankDetails:data, status:'pending', createdAt:new Date().toISOString() });
      ls.set('cm_mock_withdrawals', wd);
      return { data: { message:`Withdrawal of ${amt} USDT submitted!` } };
    }

    // Commission — subscribe
    if (endpoint === '/commission/premium/subscribe') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const plan = PREMIUM_PLANS[data.plan];
      if (!plan) throw { response:{ data:{ message:'Invalid plan' } } };
      const sub = { plan:data.plan, userId:u._id, startDate:new Date().toISOString(), endDate:new Date(Date.now()+30*86400000).toISOString(), txHash:data.txHash, benefits:plan.benefits, active:true };
      ls.set('cm_premium_sub_'+u._id, sub);
      return { data: { message:`${plan.name} plan activated!`, subscription:sub } };
    }

    // Admin — escrow actions
    if (endpoint.match(/\/admin\/escrow\/.+\/(release|refund|trusted-release)/)) {
      const parts   = endpoint.split('/');
      const orderId = parts[3];
      const action  = parts[4];
      const all = ls.get('cm_mock_orders') || {};
      Object.keys(all).forEach(uid => { all[uid] = all[uid].map(o => o._id === orderId ? {...o, status:action==='refund'?'refunded':'completed', escrowStatus:action==='refund'?'refunded':'released'} : o); });
      ls.set('cm_mock_orders', all);
      return { data: { message:`Order ${action} successful.` } };
    }

    // Fiat — convert (POST)
    if (endpoint === '/fiat/convert') {
      const cryptoAmt   = parseFloat(data.cryptoAmount) || 0;
      const cryptoPrice = CRYPTO_PRICES[data.cryptoCurrency] || 1;
      const usdValue    = cryptoAmt * cryptoPrice;
      const fiatInfo    = FIAT_DATA[data.fiatCurrency] || { rate:1, symbol:data.fiatCurrency, name:data.fiatCurrency };
      const fiatGross   = parseFloat((usdValue * fiatInfo.rate).toFixed(2));
      const fiatNet     = parseFloat((fiatGross * 0.985).toFixed(2)); // 1.5% fee
      const liveRate    = parseFloat((fiatInfo.rate * (0.995 + Math.random()*0.01)).toFixed(4));
      return { data: {
        cryptoAmount:   cryptoAmt,
        cryptoCurrency: data.cryptoCurrency,
        usdValue:       parseFloat(usdValue.toFixed(2)),
        fiatCurrency:   data.fiatCurrency,
        fiatAmount:     fiatGross,
        netFiatAmount:  fiatNet,
        fiatSymbol:     fiatInfo.symbol,
        fiatName:       fiatInfo.name,
        exchangeRate:   liveRate,
        fee:            parseFloat((fiatGross - fiatNet).toFixed(2)),
      }};
    }

    // Fiat — withdrawal request
    if (endpoint === '/fiat/withdrawal/request') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const cryptoAmt   = parseFloat(data.cryptoAmount) || 0;
      const cryptoPrice = CRYPTO_PRICES[data.cryptoCurrency] || 1;
      const usdValue    = cryptoAmt * cryptoPrice;
      const fiatInfo    = FIAT_DATA[data.fiatCurrency] || { rate:1, symbol:data.fiatCurrency, name:data.fiatCurrency };
      const fiatAmount  = parseFloat((usdValue * fiatInfo.rate * 0.985).toFixed(2));
      const record = {
        _id: 'fw_'+Date.now(), userId: u._id, username: u.username,
        cryptoCurrency: data.cryptoCurrency, amountCrypto: cryptoAmt,
        amountUSD: parseFloat(usdValue.toFixed(2)),
        fiatCurrency: data.fiatCurrency, fiatAmount,
        exchangeRate: fiatInfo.rate,
        bankDetails: data.bankDetails,
        status: 'pending', bankReference: null, createdAt: new Date().toISOString(),
      };
      const wd = ls.get('cm_mock_fiat_withdrawals') || [];
      wd.unshift(record);
      ls.set('cm_mock_fiat_withdrawals', wd);
      // Deduct wallet
      const w = getWallet(u._id);
      w.balances[data.cryptoCurrency] = Math.max(0, (w.balances[data.cryptoCurrency]||0) - cryptoAmt);
      w.transactions.unshift({ _id:'tx_'+Date.now(), type:'withdrawal', currency:data.cryptoCurrency, amount:cryptoAmt, status:'pending', date:new Date().toISOString(), note:`Bank → ${fiatInfo.symbol}${fiatAmount.toLocaleString()} ${data.fiatCurrency}` });
      saveWallet(u._id, w);
      return { data: { message:`Withdrawal submitted! You will receive ${fiatInfo.symbol}${fiatAmount.toLocaleString()} ${data.fiatCurrency} in 1–3 business days.` } };
    }

    // VTU
    if (endpoint.startsWith('/vtu/')) { return { data: { message:`${data.amount} purchased for ${data.phone||data.number}!`, reference:'VTU_'+Date.now() } }; }

    // Platform
    if (endpoint === '/platform/withdraw') { return { data: { message:'Platform withdrawal initiated.' } }; }
    if (endpoint === '/commission/admin/seed') { return { data: { message:'Seeded.' } }; }
    if (endpoint === '/admin/kyb/pending') { return { data: { message:'Done.' } }; }

    console.warn('[MockAPI] Unknown POST:', endpoint);
    return { data: {} };
  },

  // ── GET ─────────────────────────────────────────────────────────────────
  get: async (endpoint) => {
    await delay(300);
    const u = getCurrentUser();

    if (endpoint === '/auth/me') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const users = ls.get('cm_mock_users') || [];
      return { data: { user: users.find(x => x._id === u._id) || u } };
    }

    if (endpoint.startsWith('/products/featured')) {
      const limit    = parseInt(endpoint.split('limit=')[1]) || 12;
      const featured = getProducts().filter(p => p.sellerPlan==='pro'||p.sellerPlan==='standard').slice(0, limit);
      return { data: { featured } };
    }

    if (endpoint.startsWith('/products/my-products')) {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      return { data: { products: getProducts().filter(p => p.seller?._id===u._id) } };
    }

    if (endpoint.startsWith('/products/') && !endpoint.includes('?')) {
      const id = endpoint.split('/products/')[1];
      const p  = getProducts().find(p => p._id === id);
      if (!p) throw { response:{ data:{ message:'Product not found' } } };
      return { data: { product: p } };
    }

    if (endpoint.startsWith('/products')) {
      const qs       = new URLSearchParams(endpoint.includes('?') ? endpoint.split('?')[1] : '');
      const page     = parseInt(qs.get('page')) || 1;
      const limit    = parseInt(qs.get('limit')) || 20;
      const search   = qs.get('search')   || '';
      const category = qs.get('category') || '';
      const currency = qs.get('currency') || '';
      let products = getProducts();
      if (search)   products = products.filter(p => p.title?.toLowerCase().includes(search.toLowerCase())||p.description?.toLowerCase().includes(search.toLowerCase()));
      if (category) products = products.filter(p => p.category === category);
      if (currency) products = products.filter(p => p.displayCurrency === currency);
      return { data: { products: products.slice((page-1)*limit, page*limit), total: products.length, pages: Math.ceil(products.length/limit) } };
    }

    if (endpoint === '/prices/live') {
      const prices = {};
      Object.entries(CRYPTO_PRICES).forEach(([k,v]) => { prices[k] = v * (0.99 + Math.random()*0.02); });
      return { data: { prices } };
    }

    if (endpoint === '/wallet/balance') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const w = getWallet(u._id);
      const totalUSD = Object.entries(w.balances).reduce((s,[c,b]) => s+(b*(CRYPTO_PRICES[c]||0)), 0);
      return { data: { balance: w.balances, totalUSD } };
    }

    if (endpoint === '/wallet/addresses') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      return { data: { addresses: getWallet(u._id).addresses } };
    }

    if (endpoint === '/wallet/transactions') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      return { data: { transactions: getWallet(u._id).transactions || [] } };
    }

    if (endpoint === '/orders/my-orders') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      return { data: { orders: getOrders(u._id).filter(o => !o.viewAs) } };
    }

    if (endpoint === '/orders/my-sales') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      return { data: { orders: getOrders(u._id).filter(o => o.viewAs==='sale') } };
    }

    if (endpoint === '/seller/wallet') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const w = getWallet(u._id);
      return { data: { balance: w.balances, totalUSD: Object.entries(w.balances).reduce((s,[c,b])=>s+(b*(CRYPTO_PRICES[c]||0)),0), transactions: w.transactions||[] } };
    }

    if (endpoint === '/seller/wallet/withdrawals') {
      const wd = ls.get('cm_mock_withdrawals') || [];
      return { data: { withdrawals: wd.filter(w => w.userId===u?._id) } };
    }

    if (endpoint.startsWith('/stores/')) {
      const username = endpoint.split('/stores/')[1];
      const users    = ls.get('cm_mock_users') || [];
      const seller   = users.find(x => x.username===username);
      if (!seller) throw { response:{ data:{ message:'Store not found' } } };
      return { data: { store:{ username:seller.username, businessName:seller.businessName||seller.username, rating:4.8, verified:seller.kybVerified }, products: getProducts().filter(p => p.seller?.username===username) } };
    }

    if (endpoint === '/kyb/status') {
      if (!u) throw { response:{ data:{ message:'Not authenticated' } } };
      const found = (ls.get('cm_mock_users')||[]).find(x => x._id===u._id);
      return { data: { status: found?.kybStatus||'not_submitted', verified: found?.kybVerified||false } };
    }

    if (endpoint === '/commission/rates')           { return { data: { rates: COMMISSION_RATES } }; }
    if (endpoint === '/commission/premium/plans')   { return { data: { plans: PREMIUM_PLANS } }; }
    if (endpoint === '/commission/premium/my')      { return { data: { subscription: u ? ls.get('cm_premium_sub_'+u._id) : null } }; }
    if (endpoint === '/commission/my-records')      { return { data: { records: [] } }; }
    if (endpoint === '/commission/admin/premium-subs') { return { data: { subscriptions: [] } }; }
    if (endpoint === '/commission/admin/revenue')   { return { data: { revenue:{ total:4250, thisMonth:890, lastMonth:1200 } } }; }

    if (endpoint === '/support/tickets/my') {
      const tickets = ls.get('cm_mock_tickets') || [];
      return { data: { tickets: tickets.filter(t => t.userId===u?._id) } };
    }
    if (endpoint === '/support/cs/tickets')    { return { data: { tickets: ls.get('cm_mock_tickets')||[] } }; }
    if (endpoint === '/support/cs/unassigned') { const t = ls.get('cm_mock_tickets')||[]; return { data: { tickets: t.filter(x=>!x.assignedTo) } }; }
    if (endpoint === '/support/cs/stats')      { const t = ls.get('cm_mock_tickets')||[]; return { data: { open:t.filter(x=>x.status==='open').length, resolved:t.filter(x=>x.status==='resolved').length, total:t.length } }; }
    if (endpoint.startsWith('/support/tickets/')) { const id=endpoint.split('/support/tickets/')[1]; const t=(ls.get('cm_mock_tickets')||[]).find(x=>x._id===id); return { data:{ ticket:t } }; }
    if (endpoint === '/support/admin/staff')   { return { data: { staff: [] } }; }

    if (endpoint === '/loyalty/my-points') {
      const found = (ls.get('cm_mock_users')||[]).find(x => x._id===u?._id);
      return { data: { points: found?.loyaltyPoints||0, history:[] } };
    }
    if (endpoint === '/loyalty/leaderboard') { return { data: { leaderboard:[] } }; }

    if (endpoint.startsWith('/vtu/networks/')) { return { data: { plans:[{id:'p1',name:'1GB - 1 day',price:300},{id:'p2',name:'2GB - 7 days',price:500},{id:'p3',name:'5GB - 30 days',price:1000}] } }; }
    if (endpoint.startsWith('/vtu/'))          { return { data: { networks:['MTN','Airtel','Glo','9mobile'], plans:[] } }; }

    // Admin — dashboard stats
    if (endpoint === '/admin/dashboard') {
      const products = getProducts();
      const users    = ls.get('cm_mock_users') || [];
      const orders   = getAllUniqueOrders();
      const sellers  = users.filter(u => u.role==='seller');
      const now      = Date.now();
      return { data: { stats: {
        totalUsers:       users.length,
        totalSellers:     sellers.length,
        totalProducts:    products.length,
        totalOrders:      orders.length,
        totalRevenueUSD:  orders.filter(o=>o.status==='completed').reduce((s,o)=>s+(o.totalUSD||0),0),
        pendingKYB:       users.filter(u=>u.kybStatus==='pending'&&u.kybData).length,
        pendingEscrow:    orders.filter(o=>o.escrowStatus==='locked').length,
        disputedOrders:   orders.filter(o=>o.status==='disputed').length,
        dueSoonForRelease:orders.filter(o=>o.escrowStatus==='locked'&&o.createdAt&&(now-new Date(o.createdAt).getTime())>5*86400000).length,
        activeDisputes:   orders.filter(o=>o.status==='disputed').length,
      }}};
    }

    // Admin — KYB pending list  (returns { sellers: [...] } — key AdminDashboard reads)
    if (endpoint === '/admin/kyb/pending') {
      const users = ls.get('cm_mock_users') || [];
      const pending = users.filter(u => u.kybStatus==='pending' && (u.kybData||u.kyb));
      return { data: { sellers: pending } };
    }

    // Admin — disputes
    if (endpoint === '/admin/disputes') {
      return { data: { disputes: getAllUniqueOrders(o=>o.status==='disputed').map(enrichOrder) } };
    }

    // Admin — funded escrow  (enriched with buyer/seller objects so .username works)
    if (endpoint === '/admin/escrow/funded') {
      return { data: { orders: getAllUniqueOrders(o=>o.escrowStatus==='locked').map(enrichOrder) } };
    }

    if (endpoint === '/admin/risk-flags')              { return { data: { flags:[], flagged:[] } }; }
    if (endpoint === '/admin/sellers/eligible-trusted') { const users=ls.get('cm_mock_users')||[]; return { data: { sellers:users.filter(u=>u.role==='seller'&&u.kybVerified) } }; }

    if (endpoint.startsWith('/users/search')) {
      const q     = endpoint.split('q=')[1] || '';
      const users = ls.get('cm_mock_users') || [];
      return { data: { users: users.filter(u=>u.username?.includes(q)||u.email?.includes(q)) } };
    }

    // Fiat — currencies (grouped by region with full metadata)
    if (endpoint === '/fiat/currencies') {
      const grouped = {};
      Object.entries(FIAT_DATA).forEach(([code,info]) => {
        if (!grouped[info.region]) grouped[info.region] = {};
        grouped[info.region][code] = info;
      });
      return { data: { currencies: FIAT_DATA, grouped } };
    }

    if (endpoint === '/fiat/withdrawal/my')  { const wd=ls.get('cm_mock_fiat_withdrawals')||[]; return { data: { withdrawals:wd.filter(w=>w.userId===u?._id) } }; }
    if (endpoint === '/fiat/withdrawal/all') { return { data: { withdrawals: ls.get('cm_mock_fiat_withdrawals')||[] } }; }
    if (endpoint === '/fiat/convert')        { return { data: {} }; } // GET not used — POST handles conversion

    if (endpoint === '/platform/stats?days=30') { return { data: { revenue:4250, orders:128, users:342, volume:892000 } }; }
    if (endpoint === '/platform/balances')       { return { data: { balances:{ USDT:12500, BNB:45, ETH:8.2, BTC:0.35 }, totalUSD:48000 } }; }
    if (endpoint.startsWith('/platform/transactions')) { return { data: { transactions:[] } }; }

    console.warn('[MockAPI] Unknown GET:', endpoint);
    return { data: {} };
  },

  // ── PATCH ───────────────────────────────────────────────────────────────
  patch: async (endpoint, data = {}) => {
    await delay(300);

    // KYB approve
    if (endpoint.match(/\/admin\/kyb\/.+\/approve/)) {
      const userId = endpoint.split('/')[3];
      const users  = ls.get('cm_mock_users') || [];
      const idx    = users.findIndex(u => u._id === userId);
      if (idx > -1) { users[idx].kybStatus='approved'; users[idx].kybVerified=true; ls.set('cm_mock_users', users); }
      return { data: { message:'KYB approved!' } };
    }

    // KYB reject
    if (endpoint.match(/\/admin\/kyb\/.+\/reject/)) {
      const userId = endpoint.split('/')[3];
      const users  = ls.get('cm_mock_users') || [];
      const idx    = users.findIndex(u => u._id === userId);
      if (idx > -1) { users[idx].kybStatus='rejected'; users[idx].kybVerified=false; users[idx].kybRejectReason=data.reason||''; ls.set('cm_mock_users', users); }
      return { data: { message:'KYB rejected.' } };
    }

    // Mark seller as trusted/untrusted
    if (endpoint.match(/\/admin\/sellers\/.+\/trusted/)) {
      const userId = endpoint.split('/')[3];
      const users  = ls.get('cm_mock_users') || [];
      const idx    = users.findIndex(u => u._id === userId);
      if (idx > -1) { users[idx].isTrusted = data.isTrusted; ls.set('cm_mock_users', users); }
      return { data: { message:'Seller trust status updated.' } };
    }

    // Resolve dispute
    if (endpoint.match(/\/admin\/disputes\/.+\/resolve/)) {
      const orderId = endpoint.split('/')[3];
      const action  = data.action;
      const all = ls.get('cm_mock_orders') || {};
      Object.keys(all).forEach(uid => {
        all[uid] = all[uid].map(o => o._id===orderId ? {...o,
          status: action==='refund_buyer'?'refunded':'completed',
          escrowStatus: action==='refund_buyer'?'refunded':'released',
        } : o);
      });
      ls.set('cm_mock_orders', all);
      return { data: { message:'Dispute resolved.' } };
    }

    // Risk flag resolve
    if (endpoint.match(/\/admin\/sellers\/.+\/risk-flag/)) { return { data: { message:'Flag resolved.' } }; }

    // Commission rates update
    if (endpoint.startsWith('/commission/admin/rates/')) { return { data: { message:'Rate updated.' } }; }

    // Support staff promote/demote
    if (endpoint.match(/\/support\/admin\/staff\/.+\/(promote|demote)/)) {
      const userId = endpoint.split('/')[4];
      const action = endpoint.split('/').pop();
      const users  = ls.get('cm_mock_users') || [];
      const idx    = users.findIndex(u => u._id === userId);
      if (idx > -1) { users[idx].role = action==='promote'?'cs_staff':'seller'; ls.set('cm_mock_users', users); }
      return { data: { message:`User ${action}d.` } };
    }

    // Support ticket update
    if (endpoint.startsWith('/support/tickets/')) {
      const id  = endpoint.split('/support/tickets/')[1];
      const t   = ls.get('cm_mock_tickets') || [];
      const upd = t.map(x => x._id===id ? {...x,...data} : x);
      ls.set('cm_mock_tickets', upd);
      return { data: { ticket: upd.find(x=>x._id===id) } };
    }

    // Products update (PATCH alias)
    if (endpoint.startsWith('/products/')) {
      const id       = endpoint.split('/products/')[1];
      const products = getProducts();
      const updated  = products.map(p => p._id===id ? {...p,...data} : p);
      ls.set('cm_mock_products', updated);
      return { data: { product: updated.find(p=>p._id===id) } };
    }

    console.warn('[MockAPI] Unknown PATCH:', endpoint);
    return { data: {} };
  },

  // ── PUT ─────────────────────────────────────────────────────────────────
  put: async (endpoint, data = {}) => {
    await delay(300);
    if (endpoint.startsWith('/products/')) {
      const id = endpoint.split('/products/')[1];
      const updated = getProducts().map(p => p._id===id ? {...p,...data} : p);
      ls.set('cm_mock_products', updated);
      return { data: { product: updated.find(p=>p._id===id) } };
    }
    if (endpoint.startsWith('/admin/kyb/')) {
      const userId = endpoint.split('/admin/kyb/')[1];
      const users  = ls.get('cm_mock_users') || [];
      const idx    = users.findIndex(u => u._id===userId);
      if (idx>-1) { users[idx].kybStatus=data.status; users[idx].kybVerified=data.status==='approved'; ls.set('cm_mock_users', users); }
      return { data: { message:'KYB updated.' } };
    }
    console.warn('[MockAPI] Unknown PUT:', endpoint);
    return { data: {} };
  },

  // ── DELETE ──────────────────────────────────────────────────────────────
  delete: async (endpoint) => {
    await delay(300);
    if (endpoint.startsWith('/products/')) {
      const id = endpoint.split('/products/')[1];
      ls.set('cm_mock_products', getProducts().filter(p=>p._id!==id));
      return { data: { message:'Product deleted.' } };
    }
    console.warn('[MockAPI] Unknown DELETE:', endpoint);
    return { data: {} };
  },
};

export default mockApi;
